import { useMutation, useQueryClient } from 'react-query';

import { Post } from '../../../types/Post';
import Api from '../../api/api';

export const deletePost = async (postId: string) => {
  const [response, bodyOrError] = await Api.delete(`posts/${postId}`);

  if (!response.ok) {
    throw bodyOrError;
  }

  return bodyOrError;
};

export const useDeletePost = () => {
  const queryClient = useQueryClient();

  return useMutation<Post, Error, string>('deletePost', deletePost, {
    onSuccess: () => {
      queryClient.invalidateQueries('getPosts');
    },
  });
};
